import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalWindowParameters} from '../../modal-window-parameters';
import {ModalWindowResponse} from '../../modal-window-response';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalWindowService} from '../../modal-window.service';

@Component({
  selector: 'app-modal-window-qrcode-size',
  templateUrl: './modal-window-qrcode-size.component.html',
  styleUrls: ['./modal-window-qrcode-size.component.scss']
})
export class ModalWindowQrcodeSizeComponent implements OnInit {
  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();
  formGroup: FormGroup = new FormGroup({
    qrcodeWidth: new FormControl(30, [
      Validators.required,
    ]),
    qrcodeHeight: new FormControl(30, [
      Validators.required,
    ])
  });

  get qrcodeWidth() {
    return this.formGroup.get('qrcodeWidth');
  }

  get qrcodeHeight() {
    return this.formGroup.get('qrcodeHeight');
  }

  constructor() {
  }

  ngOnInit() {
    this.formGroup.get('qrcodeWidth').valueChanges.subscribe(x => {
      this.formGroup.controls.qrcodeHeight.setValue(x);
      this.formGroup.controls.qrcodeHeight.markAsTouched();
    });
  }

  onCancelClick() {
    this.modalWindowResponse.next({confirmed: false});
  }

  onApplyClick() {
    if (this.formGroup.valid) {
      this.modalWindowResponse.next({
        qrcodeWidth: this.formGroup.value.qrcodeWidth,
        qrcodeHeight: this.formGroup.value.qrcodeHeight, confirmed: true
      });
    }

  }
}
